export default {
      id: "ic-misc-social-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-social-usage",
      toString: function () {
        return this.url;
      }
    }